/**
 * Lista dos principais bancos brasileiros regulamentados pelo Banco Central
 * 
 * Inclui bancos comerciais, digitais e instituições de pagamento.
 * Fonte: BACEN - Banco Central do Brasil
 * 
 * @version 1.0.0
 * RELEASE: 2026-03-14 v1.0.0 - Criação da lista de bancos
 */

export interface BancoBrasil {
  /** Código COMPE do banco (3 dígitos) */
  codigo: string;
  /** Nome oficial do banco */
  nome: string;
  /** Se é instituição de pagamento (tipo_conta = pagamento) */
  isPagamento?: boolean;
}

/**
 * Lista dos principais bancos brasileiros regulamentados pelo BACEN
 * Ordenada por código
 */
export const BANCOS_BRASIL: BancoBrasil[] = [
  { codigo: '001', nome: 'Banco do Brasil' },
  { codigo: '003', nome: 'Banco da Amazônia' },
  { codigo: '004', nome: 'Banco do Nordeste' },
  { codigo: '021', nome: 'Banestes' },
  { codigo: '025', nome: 'Banco Alfa' },
  { codigo: '033', nome: 'Santander' },
  { codigo: '036', nome: 'Banco Bradesco BBI' },
  { codigo: '037', nome: 'Banco do Estado do Pará' },
  { codigo: '041', nome: 'Banrisul' },
  { codigo: '047', nome: 'Banco do Estado de Sergipe' },
  { codigo: '070', nome: 'BRB - Banco de Brasília' },
  { codigo: '077', nome: 'Banco Inter' },
  { codigo: '084', nome: 'Uniprime Norte do Paraná' },
  { codigo: '085', nome: 'Cooperativa Central Ailos' },
  { codigo: '104', nome: 'Caixa Econômica Federal' },
  { codigo: '133', nome: 'Cresol Confederação' },
  { codigo: '136', nome: 'Unicred' },
  { codigo: '197', nome: 'Stone Pagamentos' },
  { codigo: '208', nome: 'BTG Pactual' },
  { codigo: '212', nome: 'Banco Original' },
  { codigo: '237', nome: 'Bradesco' },
  { codigo: '246', nome: 'Banco ABC Brasil' },
  { codigo: '260', nome: 'Nubank (Nu Pagamentos)' },
  { codigo: '269', nome: 'HSBC Brasil' },
  { codigo: '290', nome: 'PagSeguro (PagBank)' },
  { codigo: '318', nome: 'BMG' },
  { codigo: '336', nome: 'C6 Bank' },
  { codigo: '341', nome: 'Itaú Unibanco' },
  { codigo: '389', nome: 'Banco Mercantil do Brasil' },
  { codigo: '399', nome: 'HSBC Bank Brasil' },
  { codigo: '422', nome: 'Safra' },
  { codigo: '461', nome: 'Asaas', isPagamento: true },
  { codigo: '655', nome: 'Banco Votorantim' },
  { codigo: '707', nome: 'Daycoval' },
  { codigo: '741', nome: 'Banco Ribeirão Preto' },
  { codigo: '745', nome: 'Citibank' },
  { codigo: '746', nome: 'Banco Modal' },
  { codigo: '748', nome: 'Sicredi' },
  { codigo: '756', nome: 'Sicoob' },
];
